<template>
    <div class="text">
        <h1>{{ $t('driver_onboarding.profile.contract.contract_is_creating_title') }} </h1>
        <span>{{ $t('driver_onboarding.profile.contract.contract_is_creating_desc') }}</span>
        <br />
        <b-button :loading="isLoading" @click.prevent="checkContract">{{ !isLoading ? $t('driver_onboarding.profile.contract.contract_is_creating_button') : '' }}</b-button>
    </div>
</template>

<script>
export default {
    data () {
        return {
            isLoading: false,
        }
    },
    methods: {
        checkContract() {
            this.isLoading = true
            const token = this.$store.getters.supplierToken
            this.$store.dispatch("getProfile", token).then(response => {
                if (response) {
                    setTimeout(() => {
                        this.isLoading = false
                        this.$buefy.notification.open({
                            message: this.$t('driver_onboarding.profile.contract.contact_to_get_contract'),
                            type: "is-warning",
                            duration: 3000,
                            position: "is-bottom",
                        });
                    }, 3000)
                }
            })
            .catch(error => {
                this.isLoading = false
                this.$buefy.notification.open({
                message: `${error.status}: ${error.data.title}`,
                type: "is-danger",
                duration: 3000,
                position: "is-bottom"
                });
            });  
            this.$gtag('event',this.$trackingEvents.EVENTS.REQUIRE_CONTRACT, {'event_category' : this.$route.path})
            
        },
    }
}
</script>
